import React from 'react';
import PropTypes from 'prop-types';

import VideoCoordinatesDataSourceField from '../../atoms/VideoCoordinatesDataSourceField';
import VideoDrawLineField from '../../atoms/VideoDrawLineField';
import VideoGeometryFileField from '../../atoms/VideoGeometryFileField';
import VideoGoProLogFileField from '../../atoms/VideoGoProLogFileField';
import VideoLogFileField from '../../atoms/VideoLogFileField';
import VideoSelectPointField from '../../atoms/VideoSelectPointField';
import VideoSourceField from '../../atoms/VideoSourceField';
import VideoURLField from '../../atoms/VideoURLField';

const VideoFields = ({
  buttonStates,
  isAutoLoadData,
  setIsAutoLoadData,
  handleSourceVideo,
  ...rest
}) => {
  return (
    <>
      <VideoSourceField handleSourceVideo={handleSourceVideo} {...rest} />
      <VideoURLField
        {...rest}
        isAutoLoadData={isAutoLoadData}
        setIsAutoLoadData={setIsAutoLoadData}
      />
      <VideoCoordinatesDataSourceField {...rest} isAutoLoadData={isAutoLoadData} />
      <VideoSelectPointField buttonActive={buttonStates.definePointActive} {...rest} />
      <VideoDrawLineField buttonActive={buttonStates.defineLineActive} {...rest} />
      <VideoGeometryFileField {...rest} />
      <VideoLogFileField {...rest} />
      <VideoGoProLogFileField {...rest} isAutoLoadData={isAutoLoadData} />
    </>
  );
};
VideoFields.defaultProps = {
  callBackGoProVideo: () => {},
  dataLoaded: false,
  disabledLoadData: false,
  changeDisabledLoadData: () => {},
  handleButtonVideoURLForm: () => {},
  handleSourceVideo: () => {}
};
VideoFields.propTypes = {
  buttonStates: PropTypes.shape({
    definePointActive: PropTypes.bool.isRequired,
    defineLineActive: PropTypes.bool.isRequired
  }).isRequired,
  callBackGoProVideo: PropTypes.func,
  isAutoLoadData: PropTypes.bool.isRequired,
  setIsAutoLoadData: PropTypes.func.isRequired,
  dataLoaded: PropTypes.bool,
  disabledLoadData: PropTypes.bool,
  changeDisabledLoadData: PropTypes.func,
  handleButtonVideoURLForm: PropTypes.func,
  handleSourceVideo: PropTypes.func
};

export default VideoFields;
